import { Injectable } from '@angular/core';
import { FilterMatchMode } from 'primeng/api';
import { PrimeNG } from 'primeng/config';

@Injectable({
  providedIn: 'root',
})
export class InternationalizationService {
  constructor(private readonly primeNgConfig: PrimeNG) {}

  setLocalization(lang: 'en' | 'it') {
    const translation = this.getLocalization(lang);
    this.primeNgConfig.setTranslation(translation);
    this.primeNgConfig.filterMatchModeOptions = {
      text: [
        FilterMatchMode.STARTS_WITH,
        FilterMatchMode.CONTAINS,
        FilterMatchMode.NOT_CONTAINS,
      ],
      numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
      ],
      date: [
        FilterMatchMode.DATE_IS,
        FilterMatchMode.DATE_IS_NOT,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
      ],
    };
  }

  private getLocalization(lang: 'en' | 'it'): any {
    const localizations = {
      en: {
        accept: 'Yes',
        addRule: 'Add Rule',
        am: 'AM',
        apply: 'Apply',
        cancel: 'Cancel',
        choose: 'Choose',
        chooseDate: 'Choose Date',
        chooseMonth: 'Choose Month',
        chooseYear: 'Choose Year',
        clear: 'Clear',
        completed: 'Completed',
        contains: 'Contains',
        custom: 'Custom',
        dateAfter: 'Date is after',
        dateBefore: 'Date is before',
        dateFormat: 'mm/dd/yy',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dayNames: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        emptyFilterMessage: 'No results found',
        emptyMessage: 'No available options',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        endsWith: 'Ends with',
        equals: 'Equals',
        fileChosenMessage: '{0} files',
        fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        filter: 'Filter',
        firstDayOfWeek: 0,
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        medium: 'Medium',
        monthNames: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        monthNamesShort: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        nextDecade: 'Next Decade',
        nextHour: 'Next Hour',
        nextMinute: 'Next Minute',
        nextMonth: 'Next Month',
        nextSecond: 'Next Second',
        nextYear: 'Next Year',
        noFileChosenMessage: 'No file chosen',
        noFilter: 'No Filter',
        notContains: 'Not contains',
        notEquals: 'Not equals',
        now: 'Now',
        passwordPrompt: 'Enter a password',
        pending: 'Pending',
        pm: 'PM',
        prevDecade: 'Previous Decade',
        prevHour: 'Previous Hour',
        prevMinute: 'Previous Minute',
        prevMonth: 'Previous Month',
        prevSecond: 'Previous Second',
        prevYear: 'Previous Year',
        reject: 'No',
        removeRule: 'Remove Rule',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected',
        showMonthAfterYear: false,
        startsWith: 'Starts with',
        strong: 'Strong',
        today: 'Today',
        upload: 'Upload',
        weak: 'Weak',
        weekHeader: 'Wk',
        aria: {
          cancelEdit: 'Cancel Edit',
          close: 'Close',
          collapseLabel: 'Collapse',
          collapseRow: 'Row Collapsed',
          editRow: 'Edit Row',
          expandLabel: 'Expand',
          expandRow: 'Row Expanded',
          falseLabel: 'False',
          filterConstraint: 'Filter Constraint',
          filterOperator: 'Filter Operator',
          firstPageLabel: 'First Page',
          gridView: 'Grid View',
          hideFilterMenu: 'Hide Filter Menu',
          jumpToPageDropdownLabel: 'Jump to Page Dropdown',
          jumpToPageInputLabel: 'Jump to Page Input',
          lastPageLabel: 'Last Page',
          listLabel: 'Option List',
          listView: 'List View',
          maximizeLabel: 'Maximize',
          minimizeLabel: 'Minimize',
          moveAllToSource: 'Move All to Source',
          moveAllToTarget: 'Move All to Target',
          moveBottom: 'Move Bottom',
          moveDown: 'Move Down',
          moveToSource: 'Move to Source',
          moveToTarget: 'Move to Target',
          moveTop: 'Move Top',
          moveUp: 'Move Up',
          navigation: 'Navigation',
          next: 'Next',
          nextPageLabel: 'Next Page',
          nullLabel: 'Not Selected',
          otpLabel: 'Please enter one time password character {0}',
          pageLabel: 'Page {page}',
          passwordHide: 'Hide Password',
          passwordShow: 'Show Password',
          prevPageLabel: 'Previous Page',
          previous: 'Previous',
          removeLabel: 'Remove',
          rotateLeft: 'Rotate Left',
          rotateRight: 'Rotate Right',
          rowsPerPageLabel: 'Rows per page',
          saveEdit: 'Save Edit',
          scrollTop: 'Scroll Top',
          selectAll: 'All items selected',
          selectColor: 'Select a color',
          selectLabel: 'Select',
          selectRow: 'Row Selected',
          showFilterMenu: 'Show Filter Menu',
          slide: 'Slide',
          slideNumber: '{slideNumber}',
          star: '1 star',
          stars: '{star} stars',
          trueLabel: 'True',
          unselectAll: 'All items unselected',
          unselectLabel: 'Unselect',
          unselectRow: 'Row Unselected',
          zoomImage: 'Zoom Image',
          zoomIn: 'Zoom In',
          zoomOut: 'Zoom Out',
        },
      },
      it: {
        accept: 'Si',
        addRule: 'Aggiungi regola',
        am: 'AM',
        apply: 'Applica',
        cancel: 'Annulla',
        choose: 'Scegli',
        chooseDate: 'Seleziona Data',
        chooseMonth: 'Seleziona Mese',
        chooseYear: 'Seleziona Anno',
        clear: 'Cancella tutto',
        completed: 'Completato',
        contains: 'Contiene',
        custom: 'Personalizzato',
        dateAfter: 'La data è successiva',
        dateBefore: 'La data è precedente',
        dateFormat: 'dd/mm/yy',
        dateIs: 'La data è',
        dateIsNot: 'La data non è',
        dayNames: [
          'Domenica',
          'Lunedi',
          'Martedì',
          'Mercoledì',
          'Giovedì',
          'Venerdì',
          'Sabato',
        ],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
        emptyFilterMessage: 'Nessuna opzione disponibile',
        emptyMessage: 'Nessun risultato trovato',
        emptySearchMessage: 'Nessun risultato trovato',
        emptySelectionMessage: 'Nessun elemento selezionato',
        endsWith: 'Finisce con',
        equals: 'Equivale',
        fileChosenMessage: '{0} file',
        fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        filter: 'Filtro',
        firstDayOfWeek: 1,
        gt: 'Maggiore di',
        gte: 'Maggiore o uguale a',
        lt: 'Minore di',
        lte: 'Minore o uguale a',
        matchAll: 'Abbina tutto',
        matchAny: 'Abbina alcuni',
        medium: 'Medio',
        monthNames: [
          'Gennaio',
          'Febbraio',
          'Marzo',
          'Aprile',
          'Maggio',
          'Giugno',
          'Luglio',
          'Agosto',
          'Settembre',
          'Ottobre',
          'Novembre',
          'Dicembre',
        ],
        monthNamesShort: [
          'Gen',
          'Feb',
          'Mar',
          'Apr',
          'Mag',
          'Giu',
          'Lug',
          'Ago',
          'Set',
          'Ott',
          'Nov',
          'Dic',
        ],
        nextDecade: 'Decade successiva',
        nextHour: 'Ora successiva',
        nextMinute: 'Minuto successivo',
        nextMonth: 'Mese successivo',
        nextSecond: 'Secondo successivo',
        nextYear: 'Anno successivo',
        noFileChosenMessage: 'Nessun file scelto',
        noFilter: 'Senza Filtro',
        notContains: 'Non contiene',
        notEquals: 'Non uguale',
        now: 'Ora attuale',
        passwordPrompt: 'Inserisci la password',
        pending: 'In corso',
        pm: 'PM',
        prevDecade: 'Decade precedente',
        prevHour: 'Ora precedente',
        prevMinute: 'Minuto precedente',
        prevMonth: 'Mese precedente',
        prevSecond: 'Secondo precedente',
        prevYear: 'Anno precedente',
        reject: 'No',
        removeRule: 'Rimuovi regola',
        searchMessage: '{0} risultati disponibili',
        selectionMessage: '{0} elementi selezionati',
        showMonthAfterYear: false,
        startsWith: 'Inizia con',
        strong: 'Forte',
        today: 'Oggi',
        upload: 'Carica',
        weak: 'Debole',
        weekHeader: 'Sett',
        aria: {
          cancelEdit: 'Annulla modifica',
          close: 'Chiudi',
          collapseLabel: 'Riduci',
          collapseRow: 'Riduci riga',
          editRow: 'Modifica riga',
          expandLabel: 'Espandi',
          expandRow: 'Espandi riga',
          falseLabel: 'Falso',
          filterConstraint: 'Costante di filtro',
          filterOperator: 'Operatore di filtro',
          firstPageLabel: 'Prima pagina',
          gridView: 'Griglia',
          hideFilterMenu: 'Nascondi Menu filtri',
          jumpToPageDropdownLabel: 'Vai alla Dropdown delle pagine',
          jumpToPageInputLabel: "Vai all'Input delle pagine",
          lastPageLabel: 'Ultima pagina',
          listLabel: 'Elenco delle opzioni',
          listView: 'Lista',
          maximizeLabel: 'Massimizzare',
          minimizeLabel: 'Minimizzare',
          moveAllToSource: 'Muovi tutto alla sorgente',
          moveAllToTarget: "Muovi tutto all'elemento",
          moveBottom: 'Vai in fondo',
          moveDown: 'Vai sotto',
          moveTop: 'Vai in cima',
          moveToSource: 'Vai alla sorgente',
          moveToTarget: "Vai all'elemento",
          moveUp: 'Vai sopra',
          navigation: 'Naviga',
          next: 'Successivo',
          nextPageLabel: 'Pagina successiva',
          nullLabel: 'Non selezionato',
          otpLabel: 'Inserisci il carattere della password monouso {0}',
          pageLabel: 'Pagina {page}',
          passwordHide: 'Nascondi password',
          passwordShow: 'Mostra password',
          previous: 'Precedente',
          prevPageLabel: 'Pagina precedente',
          removeLabel: 'Rimuovere',
          rotateLeft: 'Ruota a sinistra',
          rotateRight: 'Ruota a destra',
          rowsPerPageLabel: 'Elementi per pagina',
          saveEdit: 'Salva modifica',
          scrollTop: 'Torna sù',
          selectAll: 'Seleziona tutti gli elementi',
          selectColor: 'Seleziona un colore',
          selectLabel: 'Seleziona',
          selectRow: 'Seleziona riga',
          showFilterMenu: 'Mostra Menu filtri',
          slide: 'Scorri',
          slideNumber: '{slideNumber}',
          star: '1 stella',
          stars: '{star} stelle',
          trueLabel: 'Vero',
          unselectAll: 'Deseleziona tutti gli elementi',
          unselectLabel: 'Deseleziona',
          unselectRow: 'Deseleziona riga',
          zoomImage: 'Zoom Immagine',
          zoomIn: 'Ingrandisci',
          zoomOut: 'Riduci',
        },
      },
    };

    const localization = localizations[lang];
    return localization;
  }
}
